import jar0 from 'src/lotties/jars/00.json';
import jar1 from 'src/lotties/jars/01.json';
import jar2 from 'src/lotties/jars/02.json';
import jar3 from 'src/lotties/jars/03.json';
import jar4 from 'src/lotties/jars/04.json';
import jar5 from 'src/lotties/jars/05.json';
import jar6 from 'src/lotties/jars/06.json';
import jar7 from 'src/lotties/jars/07.json';

export const Jar0 = {
  loop: true,
  animationData: jar0,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar1 = {
  loop: true,
  animationData: jar1,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar2 = {
  loop: true,
  animationData: jar2,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar3 = {
  loop: true,
  animationData: jar3,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar4 = {
  loop: true,
  animationData: jar4,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar5 = {
  loop: true,
  animationData: jar5,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar6 = {
  loop: true,
  animationData: jar6,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};

export const Jar7 = {
  loop: true,
  animationData: jar7,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
};